import React, { useEffect, useState } from "react";
import { Badge, Card, Image, Modal } from "react-bootstrap";
import { apiGetNotifications } from "../../../api/ApiNotification";
import { toDateParseFR } from "../../../utils/datesHeures";
import logoEasyGouvOnly from "../../../assets/images/logoEasygouvOnly.png";
import { useTranslation } from "react-i18next";
import ComponentModaleNotifierListe from "../../layout/ComponentModaleNotifierListe";

const ComponentCardInstance = (props) => {
  const { t } = useTranslation();
  const { instance, selectionneInstance, derniereVisite } = props;
  const [badge, setBadge] = useState(0);
  const [showListNotifications, setShowListNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const recupNotificationsRecentes = async () => {
    const res = await apiGetNotifications(instance._id, "sort=datePeremption");
    let nbrBadge = 0;
    let notificationsToDisplay = [];

    let today = new Date();
    //   today.setDate(today.getDate() + 2);
    let todayFormat =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1 < 10 ? "0" : "") +
      (today.getMonth() + 1) +
      "-" +
      (today.getDate() < 10 ? "0" : "") +
      today.getDate();

    res.data.forEach((notification) => {
      if (
        notification.datePeremption &&
        notification.createdAt.replace("+00:00", "Z") >= derniereVisite &&
        todayFormat <= notification.datePeremption.replace("+00:00", "Z")
      ) {
        notificationsToDisplay.push(notification);
        nbrBadge++;
      }
    });
    setNotifications(notificationsToDisplay);
    setBadge(nbrBadge);
  };

  const openModalListNotifications = () => {
    setShowListNotifications(!showListNotifications);
  };

  useEffect(() => {
    recupNotificationsRecentes();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{ maxWidth: "300px", minWidth: "300px" }}
      className={"m-2 mb-5 p-2 shadow position-relative"}
    >
      {badge > 0 && notifications.length > 0 && (
        <Badge
          role="button"
          className="bg-danger position-absolute end-0 "
          onClick={(e) => openModalListNotifications()}
        >
          {badge}
        </Badge>
      )}

      <div
        className="h-100 d-flex flex-column justify-content-start align-items-center mt-4"
        onClick={(e) => selectionneInstance(instance._id)}
        role="button"
      >
        {instance.logoPic ? (
          <Image
            style={{ maxHeight: "150px", maxWidth: "150px" }}
            src={process.env.REACT_APP_URL_EXPRESS + "images/instance/" + instance.logoPic}
          />
        ) : (
          <Image style={{ maxHeight: "150px", maxWidth: "150px" }} src={logoEasyGouvOnly} />
        )}
        <Card className=" p-2 w-100 bg-body border-0">
          <Card.Body>
            <Card.Title>
              {instance.entite}

              <hr />
            </Card.Title>
            <Card.Subtitle className="mb-2 text-muted">{instance.phraseAccroche}</Card.Subtitle>
          </Card.Body>
        </Card>
      </div>

      <ComponentModaleNotifierListe
        setShowList={setShowListNotifications}
        showList={showListNotifications}
        instance={instance}
        notificationsDejaCalculees={notifications}
      />
    </div>
  );
};

export default ComponentCardInstance;
